// Réglages rarement touchés, repliés : texte de la notification, rythme des
// relances, délai de l'alerte au proche. Bornes identiques à l'api.
import { useTranslation } from 'react-i18next';

import { Champ } from '../components/champs';
import type { Formulaire, Maj } from './reglages-formulaire';

type CleNombre = 'relanceMinutes' | 'alerteMinutes' | 'ackDelaiMinutes' | 'fenetreSansFamilleH';

const BORNES: Record<CleNombre, [number, number]> = {
  relanceMinutes: [10, 15],
  alerteMinutes: [10, 180],
  ackDelaiMinutes: [2, 30],
  fenetreSansFamilleH: [1, 12],
};

export function ChampsAvances({ f, maj }: Readonly<{ f: Formulaire; maj: Maj }>) {
  const { t } = useTranslation();
  return (
    <details className="border-filet mt-10 border-t pt-4">
      <summary className="min-h-11 cursor-pointer py-2 font-semibold">
        {t('reglages.avances')}
      </summary>
      <Champ
        id="texte"
        libelle={t('reglages.texte')}
        aide={t('reglages.texteAide')}
        type="text"
        required
        maxLength={40}
        value={f.texteNotification}
        onChange={(e) => maj({ texteNotification: e.target.value })}
        className="w-full"
      />
      {(Object.keys(BORNES) as CleNombre[]).map((cle) => (
        <Champ
          key={cle}
          id={cle}
          libelle={t(`reglages.${cle}`)}
          aide={t(`reglages.${cle}Aide`)}
          type="number"
          inputMode="numeric"
          required
          min={BORNES[cle][0]}
          max={BORNES[cle][1]}
          value={f[cle]}
          onChange={(e) => maj({ [cle]: Number(e.target.value) })}
          className="w-24"
        />
      ))}
    </details>
  );
}
